module.exports = __webpack_public_path__ + "img/portraits_24_H.14f4ea03.webp";